<template>
  <table class="shipping-table">
    <thead>
      <tr>
        <th>Method</th>
        <th>Cost</th>
        <th>Estimated delivery</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="method in methods" :key="method.name">
        <td>
          <strong>{{ method.name }}</strong>
        </td>
        <td>
          {{ method.cost }}
          <span v-if="method.free" class="free-badge">Free</span>
        </td>
        <td>{{ method.eta }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "ShippingTable",
  props: {
    methods: {
      type: Array,
      required: true,
    },
  },
};
</script>
